import React from 'react';
import { FiXOctagon } from 'react-icons/fi';
import './ErrorMessage.scss';

const ErrorMessage = React.memo(function ErrorMessage({ message, iconSize, icon }) {
    if(message?.length === 0)
        return null

    return (
        <div className="error-message-container">
            {icon ? icon : <FiXOctagon size={iconSize || 50} />}
            <p>{message}</p>
        </div>
    );
});

export default ErrorMessage;
